import { Action } from 'redux';
import { Agreement } from 'types/Agreement';

export const AGREEMENTS_RESET = 'agreements/reset';
export const AGREEMENTS_FETCH_START = 'agreements/fetch_start';
export const AGREEMENTS_FETCH_SUCCESS = 'agreements/fetch_success';

export const AGREEMENTS_ERROR = 'agreements/error';

interface AgreementsResetAction extends Action<typeof AGREEMENTS_RESET> {}
interface AgreementsErrorAction extends Action<typeof AGREEMENTS_ERROR> {}

// Fetch
interface AgreementsFetchStartAction extends Action<typeof AGREEMENTS_FETCH_START> {}
interface AgreementsFetchSuccessAction extends Action<typeof AGREEMENTS_FETCH_SUCCESS> {
    payload: {
        agreements: Array<Agreement>;
    };
}

export type AgreementsAction =
    | AgreementsResetAction
    | AgreementsFetchStartAction
    | AgreementsFetchSuccessAction
    | AgreementsErrorAction;
